import { render, staticRenderFns } from "./error-report-detail.vue?vue&type=template&id=48ee4ddc&scoped=true&"
import script from "./error-report-detail.vue?vue&type=script&lang=js&"
export * from "./error-report-detail.vue?vue&type=script&lang=js&"
import style0 from "./error-report-detail.vue?vue&type=style&index=0&id=48ee4ddc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ee4ddc",
  null
  
)

export default component.exports